import classNames from "classnames";
import styles from "./Badge.module.css";

type BadgeVariant =
  | "draft"
  | "new"
  | "in_progress"
  | "completed"
  | "under_review"
  | "taken_over"
  | "rejected"
  | "internal"
  | "external"
  | "default";

interface BadgeProps {
  variant: BadgeVariant;
  label: string;
}

const variantClasses: Record<BadgeVariant, string> = {
  draft: styles["draft"],
  new: styles["new"],
  in_progress: styles["inProgress"],
  completed: styles["completed"],
  under_review: styles["underReview"],
  taken_over: styles["takenOver"],
  rejected: styles["rejected"],
  internal: styles["internal"],
  external: styles["external"],
  default: styles["default"],
};

export function Badge({ variant, label }: BadgeProps) {
  return <span className={classNames(styles["badge"], variantClasses[variant])}>{label}</span>;
}
